var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHolocaustDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EDEBE5",
    d: "M16.817 10.404l2.804-4.615c.41-.673-.103-1.516-.922-1.516h-5.606L10.803.506c-.409-.675-1.432-.675-1.842 0l-2.29 3.767H1.067c-.82 0-1.331.843-.922 1.516l2.804 4.615-2.804 4.614c-.41.674.103 1.517.922 1.517h5.606l2.29 3.767c.409.674 1.432.674 1.842 0l2.29-3.767h5.605c.82 0 1.331-.843.922-1.517l-2.804-4.614z",
    transform: "translate(.604 .487)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C9BDBA",
    strokeDasharray: "1.101 1.101",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "M16.382 8.992L17.238 7.579",
    transform: "translate(.604 .487)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C9BDBA",
    strokeDasharray: ".761 .761",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "M15.917 5.4L13.256 5.4",
    transform: "translate(.604 .487)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C9BDBA",
    strokeDasharray: ".899 .899",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "M11.797 4.247L11.098 3.094M8.434 3.478L7.736 4.631",
    transform: "translate(.604 .487)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C9BDBA",
    strokeDasharray: ".761 .761",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "M6.129 5.4L3.468 5.4",
    transform: "translate(.604 .487)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C9BDBA",
    strokeDasharray: "1.101 1.101",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "M2.813 8.05L3.669 9.462M3.383 11.816L2.527 13.228",
    transform: "translate(.604 .487)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C9BDBA",
    strokeDasharray: ".761 .761",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "M3.848 15.407L6.509 15.407",
    transform: "translate(.604 .487)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C9BDBA",
    strokeDasharray: ".899 .899",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "M7.969 16.56L8.667 17.713M11.331 17.329L12.029 16.176",
    transform: "translate(.604 .487)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C9BDBA",
    strokeDasharray: ".761 .761",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "M13.636 15.407L16.297 15.407",
    transform: "translate(.604 .487)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C9BDBA",
    strokeDasharray: "1.101 1.101",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "M16.952 12.757L16.096 11.345",
    transform: "translate(.604 .487)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C9BDBA",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "M17.522 7.109l.286-.47c.081-.137.118-.28.117-.42m-.443-.714c-.124-.067-.267-.104-.424-.104h-.38m-3.802 0h-.381l-.232-.385M10.865 2.71l-.233-.385c-.081-.135-.193-.236-.32-.305m-.86 0c-.126.069-.238.17-.32.305L8.9 2.71M7.503 5.016l-.233.385h-.38m-3.802 0h-.38c-.158 0-.301.037-.425.104m-.442.714c-.002.14.035.283.117.42l.285.47m1.71 2.824l.286.47-.285.471M2.243 13.7l-.285.47c-.082.136-.12.28-.117.42m.442.714c.124.066.267.105.424.105h.381m3.802 0h.38l.233.384m1.396 2.306l.233.384c.082.135.194.237.32.306m.86 0c.127-.07.239-.17.32-.306l.233-.384m1.398-2.306l.232-.384h.38m3.802 0h.38c.158 0 .301-.039.425-.105m.443-.714c.001-.14-.036-.284-.117-.42l-.286-.47m-1.71-2.825l-.286-.47.285-.471",
    transform: "translate(.604 .487)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolocaustDay);
export default __webpack_public_path__ + "static/media/holocaustDay.91680d03d08ac04941d85bdf7134567f.svg";
export { ForwardRef as ReactComponent };